import React from 'react';
import { Inline, Box, xcss, media } from '@atlaskit/primitives';
import { useIntl } from '@atlassian/jira-intl';
import messages from './messages';

const ClearFilterLabel = () => {
	const { formatMessage } = useIntl();
	return (
		<Inline as="span">
			<Box as="span">{formatMessage(messages.labelClear)}</Box>
			<Box as="span" xcss={labelFiltersWrapperStyles}>
				<>&nbsp;{formatMessage(messages.labelFilters)}</>
			</Box>
		</Inline>
	);
};

const labelFiltersWrapperStyles = xcss({
	// @ts-expect-error doesn't support media.below yet
	[media.below.md]: {
		display: 'none',
	},
});

export default ClearFilterLabel;
